import { render, staticRenderFns } from "./task-approve.vue?vue&type=template&id=50423fbe&scoped=true&"
import script from "./task-approve.vue?vue&type=script&lang=js&"
export * from "./task-approve.vue?vue&type=script&lang=js&"
import style0 from "./task-approve.vue?vue&type=style&index=0&id=50423fbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50423fbe",
  null
  
)

export default component.exports